module.exports = __webpack_public_path__ + "img/9791156331827.12d19cb8.jpg";